import { render, staticRenderFns } from "./DocumentVersionRedirectionPage.vue?vue&type=template&id=174164b8"
import script from "./DocumentVersionRedirectionPage.vue?vue&type=script&lang=ts"
export * from "./DocumentVersionRedirectionPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports